import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

export function useShouldUseNewStripeOnboarding(): boolean {
  const worker = useDefinedWorker();
  const isNewStripeOnboardingEnabled = useCbhFlag(CbhFeatureFlag.ENABLE_NEW_STRIPE_ONBOARDING, {
    defaultValue: false,
  });

  // isOnboardingCompleted must be strictly equal to false
  // If it is undefined, then the user is on the old onboarding flow
  // If it is true, then the user has completed the onboarding flow
  return isNewStripeOnboardingEnabled && worker.paymentAccountInfo?.isOnboardingCompleted === false;
}
